<div *ngIf="isMobile; else webLogin" class="full-container">
    <div *ngIf="!otp_requested" class="full-container">
      <app-auth-header [title]="'P2P Energy Trading Platform'"></app-auth-header>
      <div class="login-container">
        <div class="container-elements">
          <div class="mobile-header">
            <!-- <img class="mobile-img-logo" src="assets/hygge_white_logo.png"/> -->
            <div class="mobile-title">Log In</div>
          </div>
          <div class="form-container">
            <label for="mobile-number" class="form-label">Enter your mobile number</label>
            <div class="form-description">We will send you a 6-digit verification code.</div>
            <div class="input-container">
              <div class="phone-number-input">
                <span class="prefix">+91-</span>
                <form  [formGroup]="reactiveForm">
                  <input type="text" id="enter-mobile-number" formControlName="phone_number" name="phone_number"
                  placeholder="" class="full-width-input spaced-input" required
                  autocomplete="new-password" [maxLength]="maxPhoneDigits" appOnlyNumber
                  pattern="[0-9]*" inputmode="decimal" (keyup.enter)="onPhoneNumberSubmit()" />
                </form>
              </div>
              <div class="terms-and-privacy-policy-container">
                <div>
                  <input id="agreementCheckbox" type="checkbox" (click)="onCheckboxClick($event)"> 
                </div>
                <div class="agreement">
                  I agree to the <span>Terms</span> & <span>Privacy Policy.</span>
                </div>
              </div>
            </div>
            <div class="get-otp">
              <button 
                (click)="onPhoneNumberSubmit()" 
                [disabled]="is_loading || !get_phone_number?.valid || !is_checked"
              >
                GET OTP
              </button>
              <label *ngIf="!is_authorized" class="unauthorized-mobile">Phone number is not authorized</label>
              <label *ngIf="max_attempts_reached" class="unauthorized-mobile">Reached max verification attempts</label>
              <label *ngIf="unexpected_error" class="unauthorized-mobile">Unexpected error please try later</label>
              <label *ngIf="phone_number_error" class="unauthorized-mobile">Phone number must be 10 digits</label>
              <label *ngIf="terms_and_privacy_policy_error" class="unauthorized-mobile">Please accept the terms and privacy policy</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="otp_requested && is_authorized" class="full-container">
      <app-auth-header [title]="'P2P Energy Trading Platform'"></app-auth-header>
      <div class="otp-container">
        <div class="container-elements">
          <div class="mobile-header">
            <div class="mobile-title">OTP Verification</div>
          </div>
          <div class="form-container">
            <label for="mobile-number" class="form-label" style="font-weight: 600;">Enter the OTP sent to</label>
            <div class="otp-form-description">+91-{{reactiveForm.get('phone_number')?.value}}</div>
            <div class="input-container">
              <div class="otp-input-container">
                <form [formGroup]="reactiveForm">
                  <div class="otp-box">
                    <input #otpInput 
                      *ngFor="let otpPart of otpParts; let i = index; let isFirst = first; let isLast = last"
                      type="text" 
                      [id]="otpPart" 
                      class="otp-input-mobile" 
                      [name]="otpPart" 
                      placeholder="" 
                      min="0" 
                      max="9" 
                      pattern="[0-9]*"
         i            inputmode="decimal"
                      required
                      [formControlName]="otpPart" 
                      autocomplete="new-password" 
                      maxLength="1" 
                      appOnlyNumber 
                      (keyup)="onOtpInputKeyUp($event, isLast ? -1 : i+1, isFirst ? -1 : i-1)"  
                      (keyup.enter)="onOtpSubmit()" 
                    />
                  </div>
                </form>
              </div>
              <div class="resend-otp">
                Didn't Receive OTP? <span>Resend OTP</span>
              </div>
            </div>
            <div class="submit-otp">
              <button  (click)="onOtpSubmit()" [disabled]="is_loading || !reactiveForm.valid">CONTINUE</button>
            </div>
            <label *ngIf="otp_error" class="unauthorized-mobile">Invalid OTP</label>
          </div>
        </div>
      </div>
    </div>
</div>


<ng-template #webLogin>
<div class="header">
  <img (click)="navigateTo('welcome')" class="img logo" src="assets/logo_transparent.png"/>
<div class="title">Peer to Peer Solar Energy Trading, {{headerLabel}}</div>
</div>
  <div disabled *ngIf="!otp_requested" class="login__screen">
    <!-- <img class="img-bescom" src="assets/bescom logo.svg"> -->
       <img class="img-1" src="assets/logo_with_text.png">
    <div class="login__form-container">
      <img class="img-2" src="assets/logo_transparent.png">
      <form  [formGroup]="reactiveForm">
        <h4 id="login__enter-mobile-header">{{formLabel}}</h4>
        <label class="login__enter-mobile-label">Enter Mobile Number</label>
        <input type="text" id="login__enter-mobile-input" formControlName="phone_number" name="phone_number"
          placeholder="" class="full-width-input spaced-input" required
          pattern="[0-9]*" inputmode="numeric" autocomplete="new-password" 
          maxLength="{{maxPhoneDigits}}" appOnlyNumber  (keyup.enter)="onPhoneNumberSubmit()" />
      </form>
      <button (click)="onPhoneNumberSubmit()" [disabled]="is_loading || !get_phone_number?.valid"
      class="login__get-otp-button">Next</button>
      <label *ngIf="!is_authorized" class="unauthorized">Phone number is not authorized</label>
      <label *ngIf="max_attempts_reached" class="unauthorized">Reached max verification attempts</label>
      <label *ngIf="unexpected_error" class="unauthorized">Unexpected error please try later</label>
    </div>
  </div>
  <div *ngIf="otp_requested && is_authorized" class=login__screen>
    <!-- <img class="img-bescom" src="assets/bescom logo.svg"> -->
      <img class="img-1" src="assets/logo_with_text.png">
    <div class="login__form-container">
      <img class="img-2" src="assets/logo_transparent.png">
      <form [formGroup]="reactiveForm" (ngSubmit)="onOtpSubmit()">
        <h4 id="login__enter-otp-header">Enter OTP</h4>
        <label>Enter 6-digit verification code sent to your mobile number.</label>
        <div id="otp-inputs">
          <input #otpInput *ngFor="let otpPart of otpParts; let i = index; let isFirst = first; let isLast = last" 
                 type="text" [id]="otpPart" class="otp-input" [name]="otpPart" placeholder="" min="0" max="9" required
                 [formControlName]="otpPart" autocomplete="new-password" maxLength="1" appOnlyNumber pattern="[0-9]*" inputmode="numeric" 
                 (keyup)="onOtpInputKeyUp($event, isLast ? -1 : i+1, isFirst ? -1 : i-1)"  (keyup.enter)="onOtpSubmit()" />
        </div>
      </form>
      <button  (click)="onOtpSubmit()" [disabled]="is_loading || !reactiveForm.valid" class="login__get-otp-button">Login</button>
      <label *ngIf="otp_error" class="unauthorized">Invalid OTP</label>
    </div>
  </div>
</ng-template>